import _ from 'lodash'

export function countBy(...params: any[]): any {
  return _.countBy.apply(null, params)
}

export function every(...params: any[]): boolean {
  return _.every.apply(null, params)
}

export function filter(collection: any, predicate?: any): any[] {
  return _.filter(collection, predicate)
}

export function find(collection: any, predicate?: any): any | undefined {
  return _.find(collection, predicate)
}

export function findLast(collection: any, predicate?: any): any | undefined {
  return _.findLast(collection, predicate)
}

export function flatMap(...params: any[]): any[] {
  return _.flatMap.apply(null, params)
}

export function groupBy(collection: any, iteratee?: any): any {
  return _.groupBy(collection, iteratee)
}

export function includes(collection: any, target: any, fromIdx: number): boolean {
  return _.includes(collection, target, fromIdx)
}

export function keyBy(collection: any, iteratee?: any): any {
  return _.keyBy(collection, iteratee)
}

export function map(...params: any[]): any[] {
  return _.map.apply(null, params)
}

export function orderBy(collection: any, iteratees?: any, orders?: any): any[] {
  return _.orderBy(collection, iteratees, orders)
}

export function partition(collection: any, predicate?: any): any[] {
  return _.partition(collection, predicate)
}

export function reject(collection: any, predicate?: any): any[] {
  return _.reject(collection, predicate)
}

export function sample(collection: any): any {
  return _.sample(collection)
}

export function sampleSize(collection: any, n?: number): any[] {
  return _.sampleSize(collection, n)
}

export function shuffle(collection: any): any[] {
  return _.shuffle(collection)
}

export function size(collection: any) {
  return _.size(collection)
}

export function some(collection: any, predicate?: any): boolean {
  return _.some(collection, predicate)
}

export function sortBy(collection: any, iteratees?: any): any[] {
  return _.sortBy(collection, iteratees)
}
